import type { Permission } from '@almacen/shared';
import { Button, SimpleGrid } from '@mantine/core';
import {
  IconBarcode,
  IconFileInvoice,
  IconLayoutGrid,
  IconPackages,
  IconSearch,
  IconTruckDelivery,
  IconTruckLoading,
  IconUsers,
  type Icon,
} from '@tabler/icons-react';
import { Link } from 'react-router';
import { useAuth } from '../../auth/auth-context';

interface QuickAction {
  label: string;
  to: string;
  icon: Icon;
  color: string;
  permission: Permission;
}

const QUICK_ACTIONS: QuickAction[] = [
  {
    label: 'Registrar entrada',
    to: '/entrada',
    icon: IconTruckDelivery,
    color: 'green',
    permission: 'pallets.entry',
  },
  {
    label: 'Ubicar / mover',
    to: '/ubicar',
    icon: IconBarcode,
    color: 'teal',
    permission: 'pallets.locate',
  },
  {
    label: 'Preparar salida',
    to: '/salidas/nueva',
    icon: IconTruckLoading,
    color: 'orange',
    permission: 'outbound.manage',
  },
  {
    label: 'Buscar palet',
    to: '/buscar',
    icon: IconSearch,
    color: 'blue',
    permission: 'pallets.read',
  },
  {
    label: 'Inventario',
    to: '/inventario',
    icon: IconPackages,
    color: 'indigo',
    permission: 'pallets.read',
  },
  {
    label: 'Mapa almacén',
    to: '/mapa',
    icon: IconLayoutGrid,
    color: 'grape',
    permission: 'locations.read',
  },
  {
    label: 'Clientes',
    to: '/clientes',
    icon: IconUsers,
    color: 'cyan',
    permission: 'clients.read',
  },
  {
    label: 'Facturación',
    to: '/liquidaciones',
    icon: IconFileInvoice,
    color: 'pink',
    permission: 'billing.read',
  },
];

/** Accesos rápidos con botones grandes (uso cómodo en tablet). */
export function QuickActions() {
  const { can } = useAuth();
  const actions = QUICK_ACTIONS.filter((action) => can(action.permission));
  return (
    <SimpleGrid cols={{ base: 2, sm: 3, lg: 4 }} spacing="md">
      {actions.map((action) => (
        <Button
          key={action.to}
          component={Link}
          to={action.to}
          color={action.color}
          size="xl"
          h={84}
          leftSection={<action.icon size={28} />}
          styles={{ label: { whiteSpace: 'normal', textAlign: 'left', lineHeight: 1.2 } }}
        >
          {action.label}
        </Button>
      ))}
    </SimpleGrid>
  );
}
